export class DropdownItem {

    constructor(public key: string, public value: string) {
        this.key = key;
        this.value = value;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/dropdown-item.ts